var _Rect, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SvgManagerIndicator(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 20,
    height: 20,
    rx: 8,
    fill: "#F99D00"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M5.042 5.273h2.096l2.807 6.85h.11l2.807-6.85h2.096v9.454h-1.643V8.232h-.088L10.614 14.7H9.386L6.773 8.218h-.088v6.51H5.042V5.272z",
    fill: "#fff"
  })));
}
export default SvgManagerIndicator;